module.exports = __webpack_public_path__ + "img/mood_hot.78f744f1.png";